import tw from 'twin.macro'
import React, { useEffect, useState } from 'react'

export default function CheckBox({ label, defaultChecked = false, value = undefined, onUpdate = undefined, ...other }) {
  const [isChecked, setIsChecked] = useState(defaultChecked || value)

  useEffect(() => {
    if (value !== undefined && value !== isChecked) setIsChecked(value)
  }, [value])

  return (
    <label
      tw="flex items-center"
      css={[other.disabled ? tw`text-gray-500 cursor-not-allowed` : tw`cursor-pointer`]}
      className="group"
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          setIsChecked((prev) => {
            if (onUpdate) onUpdate(!prev)
            return !prev
          })
        }}
        tw="w-5 h-5 mr-2 transition-all "
        css={[
          other.disabled
            ? tw`cursor-not-allowed`
            : tw`cursor-pointer focus:(outline-none ring-2 ring-primaryBlue) group-hover:drop-shadow-[0 0 5px #175ddc]`,
        ]}
        {...other}
      />
      {label}
    </label>
  )
}
